import { Injectable } from '@angular/core';

import {
  Activity,
  ActivityGroup,
  ActivityMobilisation,
  ActivityStream,
  Location,
} from '@shared/models/project-setup';

@Injectable()
export class DprActivitiesGridService {
  getActivityGroupOptions(
    activityStreamId: number,
    activityGroups: ActivityGroup[],
    selectedActivityGroupId?: number
  ): ActivityGroup[] {
    const result = activityGroups
      .filter(
        (activityGroup) =>
          activityGroup.activityGroupActivityStreamList.some(
            (x) => x.activityStreamId === activityStreamId
          ) &&
          (activityGroup.id === selectedActivityGroupId ||
            activityGroup.isActive)
      )
      .sort((x) => x.priority);

    return result;
  }

  getActivityOptions(
    activityGroupId: number,
    activities: Activity[],
    activityId?: number
  ): Activity[] {
    const result = activities
      .filter(
        (activity) =>
          activity.activityGroupId === activityGroupId &&
          (activity.id === activityId || activity.isActive)
      )
      .sort((x) => x.priority);

    return result;
  }

  getLocationOptions(
    activityId: number,
    locations: Location[],
    activities: Activity[],
    locationId?: number
  ): Location[] {
    const activity = activities.find((x) => x.id === activityId);

    if (activity?.allLocations) {
      return locations
        .filter((x) => x.id === locationId || x.isActive)
        .sort((x) => x.priority);
    }

    const result = locations
      .filter(
        (x) =>
          x.locationCategoryId === activity?.locationCategoryId &&
          (x.id === locationId || x.isActive)
      )
      .sort((x) => x.priority);

    return result;
  }

  /**
   * @description gets the activity mobilisation of the given activity stream
   */
  getActivityMobilisation(
    activityStream: ActivityStream,
    activityMobilisation: ActivityMobilisation[]
  ): ActivityMobilisation[] {
    return activityMobilisation?.filter(
      (x) =>
        (x.parallelActivityType ?? 0) ===
        (activityStream.parallelActivityType ?? 0)
    );
  }
}
